export default "__VITE_ASSET__CZxdZINw__"